import { Result } from "@coveo/headless";

/**
 * Get ordered results by filtering with a numeric field,
 * sorting them, and limiting the output.
 */
export function getOrderedResults<T extends string>(
  results: Result[],
  orderField: T,
  options?: {
    limit?: number;
    ascending?: boolean;
    minValue?: number;
  },
): Array<Result & { raw: { [K in T]: number } }> {
  const { limit = 7, ascending = true, minValue = 0 } = options || {};

  return results
    .filter((result) => hasNumericField(result, orderField, minValue))
    .sort((resultA, resultB) => {
      const diff = resultA.raw[orderField] - resultB.raw[orderField];
      return ascending ? diff : -diff;
    })
    .slice(0, limit);
}

function hasNumericField<T extends string>(
  result: Result,
  field: T,
  minValue = 0,
): result is Result & { raw: { [K in T]: number } } {
  const value = result.raw?.[field];
  return typeof value === "number" && value >= minValue;
}
